module.exports = __webpack_public_path__ + "img/splitcast.5e35a173.png";